export default __webpack_public_path__ + "static/media/3.f53ed61a.svg";